import { ErrorInfo, ErrorCode } from "@/network/http";
import { requestData } from './base'
import { 
    GetAreasReq, 
    GetAreasRsp,
    GetBannerListReq,
    GetBannerListRsp
} from '@/data/remote/common'
import { AreaInfo, BannerInfo } from "@/data/local/common";

const URL_GET_AREAS = "/common/getAreas";//获取城市地区信息
const URL_GET_BANNER_LIST = "/common/getBannerList";//获取Banner


/**
 * 获取所有省份城市
 * @param params 
 * @param callback 
 */
export const getAllAreas = (callback?: (errorInfo: ErrorInfo, data: AreaInfo[]) => void) => {
    const payload: GetAreasReq = {
        parentId: null,
        all: 1
    };

    requestData(URL_GET_AREAS, payload, (errorInfo: ErrorInfo, data: GetAreasRsp) => {
        let rspData: AreaInfo[] = (errorInfo.errorCode === ErrorCode.SUCCESS) ? [...data.list] : [];
        callback && callback(errorInfo, rspData);
    });
}

export const getBannerList = (type: number | null, callback?: (errorInfo: ErrorInfo, data: BannerInfo[]) => void) => {
    const payload: GetBannerListReq = {
        type
    };

    requestData(URL_GET_BANNER_LIST, payload, (errorInfo: ErrorInfo, data: GetBannerListRsp) => {
        let rspData: BannerInfo[] = (errorInfo.errorCode === ErrorCode.SUCCESS) ? [...data.list] : [];
        callback && callback(errorInfo, rspData);
    });
}